var React = require('react');

function IconHornCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.3 63.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm32.9 649.2c0 33-26.1 25.7-42.5 11.4l-112.8-97.9H258.8c-1 0-1.7-.7-1.7-1.7l-.7-218.1c0-.9.8-1.7 1.7-1.7h136.7s74.4-68.4 105.6-95.8c31.2-27.4 43.7 8.9 43.7 8.9v394.9h.1zm72.3-76c-15.6 11.5-43.9-9.7-31-25.5 25.9-22.4 42.5-52.7 44.3-86.6 2-38.4-15.6-73.7-45.2-98.9-11.3-12.1 14.3-37.8 32.5-24.3 36.7 32.2 58.4 76.6 55.9 124.8-2.3 43.2-23.4 81.8-56.5 110.5zM767.9 530c-3.3 64.6-36.2 122.1-87.1 163.7-11.7 9.1-46.8-11-32-28.7 42.4-34.7 69.8-82.8 72.6-136.7 3.1-59.4-24.3-113.8-70.5-152.6-10.9-14.9 15.4-39.6 33.3-27.6 54.8 46.3 87.3 111.2 83.7 181.9z"}));
}

IconHornCircleSolid.displayName = "IconHornCircleSolid";

IconHornCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconHornCircleSolid;

IconHornCircleSolid.default = IconHornCircleSolid;
